import { types } from 'mobx-state-tree';
import { DictationSentence } from './sentence.store';

export const DictationStore = types
  .model('DictationStore', {
    sentences: types.array(DictationSentence),
    currentSentenceIndex: types.optional(types.number, 0),
  })
  .actions((self) => {
    return {
      setCurrentSentenceIndex(index) {
        self.currentSentenceIndex = index;
      },
    };
  })
  .views((self) => {
    return {
      get currentSentence() {
        return self.sentences[self.currentSentenceIndex];
      },
      get isLastSentence() {
        return self.currentSentenceIndex === self.sentences.length - 1;
      },
    };
  });
